module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.type != 1) ? _c('div', {
    staticClass: "content-shareimg",
    on: {
      "click": _vm.toShare
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.shareimage,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.status || _vm.statuses) ? _c('section', {
    staticClass: "toast-bg",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.toCancel($event)
      }
    }
  }, [(_vm.statuses) ? _c('img', {
    staticClass: "img-share",
    attrs: {
      "src": require("../../assets/img/icon/shares.png"),
      "alt": ""
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.status) ? _c('div', {
    staticClass: "toast-box border-radius-10"
  }, [_c('p', {
    staticClass: "share-title text-center"
  }, [_vm._v("分享")]), _vm._v(" "), _c('p', {
    staticClass: "share-title text-center"
  }, [_c('a', {
    staticClass: "icons qzone",
    attrs: {
      "href": 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + _vm.upVal(_vm.link) + '&title=' + _vm.upVal(_vm.title) + '&pics=' + _vm.upVal(_vm.desc) + '&summary=' + _vm.upVal(_vm.title) + '&site=' + _vm.upVal(_vm.title) + '&pics=' + _vm.img + '&site=' + _vm.upVal(_vm.title) + ''
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "icons qq",
    attrs: {
      "href": 'http://connect.qq.com/widget/shareqq/index.html?url=' + _vm.upVal(_vm.link) + '&title=' + _vm.upVal(_vm.title) + '&source=亚朵&desc=' + _vm.upVal(_vm.desc) + '&pics=' + _vm.upVal(_vm.img)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "icons weibo",
    attrs: {
      "href": 'http://service.weibo.com/share/share.php?url=' + _vm.upVal(_vm.link) + '&title=' + _vm.upVal(_vm.title) + '&pic=' + _vm.upVal(_vm.img) + '&appkey='
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "share-cancle text-center",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.toCancel($event)
      }
    }
  }, [_vm._v("取消")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bd82890!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/share.vue
// module id = 130
// module chunks = 2